<template>
	<div>
		<modal index="11188" name="cp-modal-excluir">
			<div class="row">
				<div class="col-md-12">
					<h4>
						{{ textoBotao }}
					</h4>
				</div>
			</div>

			<hr style="margin-top: 0px; margin-bottom: 10px" />

			<div class="row">
				<div class="col-xs-12 text-center" v-html="texto"></div>
			</div>

			<hr style="margin-top: 20px; margin-bottom: 10px" />
			<div class="row" v-if="justificativa">
				<div class="col-xs-12 form-group"> <label for="">Observações:</label> <textarea class="form-control" cols="30" rows="10" v-model="objeto.observacaoCancelamento"></textarea></div>
			</div>

			<div class="row">
				<div class="col-xs-6">
					<button class="btn btn-default pull-left" type="button" @click="clickFechar()">
						<i class="fa fa-times"></i> {{ _traducao('global', 'fechar').toUpperCase() }}
					</button>
				</div>

				<div class="col-xs-6">
					<button class="btn btn-danger pull-right" type="button" @click="clickExcluir()">
						<i class="fa fa-trash"></i> {{ textoBotao }}
					</button>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
export default {
	data() {
		return {
			texto: '',
			textoBotao: '',
			objeto: {},
			justificativa: false,
		}
	},

	mounted() {
		bus.$on('cp-carrega-modal-excluir', (texto, textoBotao, obj, justificativa) => {
			this.texto = texto
			this.textoBotao = textoBotao
			this.justificativa = justificativa
			this.objeto = obj
			if(justificativa){
				this.objeto.observacaoCancelamento = ''
			}
			this._exibeModal('cp-modal-excluir', 60)
		})
	},

	methods: {
		clickFechar() {
			this._escondeModal('cp-modal-excluir')
			bus.$emit('cp-modal-excluir-fechou')
		},

		clickExcluir() {
			this._escondeModal('cp-modal-excluir')
			bus.$emit('cp-modal-excluir-excluir', this.objeto)
		}
	}
}
</script>